/**
 * A custom element that renders a results list.
 */
export default class ResultsList extends HTMLElement {}

if (!customElements.get('results-list')) {
  customElements.define('results-list', ResultsList);
}
